import { RESOURCE_NOT_FOUND } from "apis";
import { BASE } from "constants/routes";
import { SCORING_NOT_AVAILABLE_ERROR_CODE } from "constants/scoring";
import { modalTypes } from "constants/types";
import { get } from "lodash";
import { removeAllMetadata } from "slices/addIn/metadata/actions";
import { showErrorModal } from "slices/app/actions/error";
import { hideModal, showModal } from "slices/app/actions/modals";
import { navigateTo } from "utils/navigation";

import { setScoringUnavailable } from "./scoring/analysis/analysisSlice";

const NOT_FOUND_MESSAGE =
  "This document has been deleted in VisibleThread, so your changes can't be saved to it. Your Word document is unaffected - upload it again to save it as a new document.";

export const parseDocumentError = (error) => (dispatch) => {
  const status = get(error, ["response", "status"]);

  const onCloseError = async () => {
    dispatch(hideModal(modalTypes.ERROR));
    navigateTo(BASE);
    await dispatch(removeAllMetadata());
  };

  if (status === RESOURCE_NOT_FOUND) {
    dispatch(
      showModal(modalTypes.ERROR, {
        errorMessage: NOT_FOUND_MESSAGE,
        handleOk: onCloseError,
        title: "Document No Longer Available",
      })
    );
    return status;
  }
  return false;
};

export const parseScoringError = (error) => (dispatch) => {
  const { data } = error?.response || {};
  const errorCode = data?.errorCode;
  const statusError = dispatch(parseDocumentError(error));

  if (statusError) return statusError;

  if (errorCode === SCORING_NOT_AVAILABLE_ERROR_CODE) {
    dispatch(setScoringUnavailable(true));
  } else {
    dispatch(showErrorModal(error));
  }
};
